/* ===== Lazy Script Loader ===== */
const scriptPromises = new Map();

export function loadScriptOnce(url, globalName, timeoutMs = 8000) {
  const key = globalName || url;
  if (globalName && typeof window !== 'undefined' && window[globalName]) {
    return Promise.resolve(window[globalName]);
  }

  if (scriptPromises.has(key)) {
    return scriptPromises.get(key);
  }

  const promise = new Promise((resolve, reject) => {
    if (typeof document === 'undefined') {
      reject(new Error('No document available to load script'));
      return;
    }

    const existing = document.querySelector(`script[data-lazy-loader="${key}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve(globalName ? window[globalName] : true), { once: true });
      existing.addEventListener('error', () => reject(new Error(`Failed to load script: ${url}`)), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.dataset.lazyLoader = key;

    const timeout = setTimeout(() => {
      reject(new Error(`Timeout loading script: ${url}`));
    }, timeoutMs);

    script.addEventListener('load', () => {
      clearTimeout(timeout);
      if (globalName && typeof window !== 'undefined') {
        resolve(window[globalName]);
        return;
      }
      resolve(true);
    }, { once: true });

    script.addEventListener('error', () => {
      clearTimeout(timeout);
      reject(new Error(`Failed to load script: ${url}`));
    }, { once: true });

    document.head.appendChild(script);
  });

  scriptPromises.set(key, promise);
  return promise;
}
